.item {
  display: flex;
  align-items: center;
  padding: var(--ant-padding-xs) var(--ant-padding-sm);
  border-bottom: 1px solid var(--ant-color-bg-layout);
  background-color: var(--ant-color-off-white-1);
  margin-bottom: var(--ant-margin-xs);
}

.dragHandle {
  margin-right: var(--ant-margin-sm);
  cursor: grab;
  font-size: var(--ant-font-size-lg);
  color: var(--ant-color-text-secondary);
}

.title {
  flex: 1;
}
